var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSelection = function SvgIconSelection(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 2.75a1 1 0 0 0 0 2h3a1 1 0 1 0 0-2zM10.5 19.25a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2zM16.25 3.75a1 1 0 0 1 1-1h2.25a1.75 1.75 0 0 1 1.75 1.75v2.25a1 1 0 1 1-2 0v-2h-2a1 1 0 0 1-1-1M21.25 10.5a1 1 0 1 0-2 0v3a1 1 0 1 0 2 0zM20.25 16.25a1 1 0 0 1 1 1v2.25a1.75 1.75 0 0 1-1.75 1.75h-2.25a1 1 0 1 1 0-2h2v-2a1 1 0 0 1 1-1M4.75 10.5a1 1 0 0 0-2 0v3a1 1 0 1 0 2 0zM3.75 16.25a1 1 0 0 1 1 1v2h2a1 1 0 1 1 0 2H4.5a1.75 1.75 0 0 1-1.75-1.75v-2.25a1 1 0 0 1 1-1M4.5 2.75A1.75 1.75 0 0 0 2.75 4.5v2.25a1 1 0 0 0 2 0v-2h2a1 1 0 0 0 0-2z"
  }))));
};
export default SvgIconSelection;